import axios from 'axios'
import errorParser from '@/utils/error-parser'

export default {
  /**
   * Admin-only listing of all API tokens (metadata only, no secrets).
   */
  listApiTokens () {
    return new Promise((resolve, reject) => {
      axios.get('/apitokens').then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  /**
   * Creates a read-only API token bound to one organization.
   * The response contains the cleartext token exactly once.
   * @param {Object} payload { organizationId, name, expiresAt ("yyyy-MM-dd" or null) }
   */
  createApiToken (payload) {
    return new Promise((resolve, reject) => {
      axios.post('/apitokens', payload).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  },

  /**
   * Revokes (deactivates) a token. The row is kept for auditing.
   */
  revokeApiToken (id) {
    return new Promise((resolve, reject) => {
      axios.delete('/apitokens/' + id).then(({ data }) => {
        resolve(data)
      }).catch((error) => {
        reject(errorParser.parse(error))
      })
    })
  }
}
